import { render, staticRenderFns } from "./CashierProducts.vue?vue&type=template&id=15af3a7b&scoped=true"
import script from "./CashierProducts.vue?vue&type=script&lang=ts"
export * from "./CashierProducts.vue?vue&type=script&lang=ts"
import style0 from "./CashierProducts.vue?vue&type=style&index=0&id=15af3a7b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15af3a7b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15af3a7b')) {
      api.createRecord('15af3a7b', component.options)
    } else {
      api.reload('15af3a7b', component.options)
    }
    module.hot.accept("./CashierProducts.vue?vue&type=template&id=15af3a7b&scoped=true", function () {
      api.rerender('15af3a7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cashier/CashierProducts.vue"
export default component.exports